/* import __COLOCATED_TEMPLATE__ from './header.hbs'; */
import templateOnly from '@ember/component/template-only';

export interface BvModalHeaderSignature {
  Args: {
    hideCloseButton?: boolean;
    onClose?: () => void;
    subdued?: boolean;
    subtitle?: string;
    title?: string;
    titleAction?: () => void;
    titleLinkIcon?: string;
  };
  Blocks: {
    default: [];
    titleAction: [];
  };
  Element: HTMLElement;
}

const BvModalHeaderComponent = templateOnly<BvModalHeaderSignature>('BvModal::Header');

export default BvModalHeaderComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvModal::Header': typeof BvModalHeaderComponent;
    'bv-modal/header': typeof BvModalHeaderComponent;
  }
}
